module.exports = __webpack_public_path__ + "static/img/info3.3c928d43.jpg";